export enum PhysicalStreamType {
    PRESENT = "PRESENT",
    DATA = "DATA",
    OFFSET = "OFFSET",
    LENGTH = "LENGTH",
}
